import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Location } from '@angular/common';
import { Invoice } from '../../invoice/invoice';
import { InvoiceService } from '../../invoice/invoice.service';
import { InvoiceListPipe } from '../../pipe/invoicelist.pipe';

@Component({
  selector: 'app-paid-invoices',
  templateUrl: './paid-invoices.component.html',
  styleUrls: ['./paid-invoices.component.css']
})
export class PaidInvoicesComponent implements OnInit {

  serchText:string= '';
  page=1;
  currentPage = 1;
  itemsPerPage = 5;
  pageSize: number;
  totalrecord:number;
  submitted = false;
  message: string;	
  invoice = new Invoice();
  invoices: Invoice[];
  invoiceFilter: any = { invoiceno: '' };
  constructor(
    private invoiceService: InvoiceService,
    private route: ActivatedRoute,
    private spinnerService: Ng4LoadingSpinnerService,
    private location: Location
    ) { }

  ngOnInit() {
	  this.getPaidInvoices();
  }
  getPaidInvoices() {
    return this.invoiceService.getPaidInvoices()
               .subscribe(
                invoicedata => {
                  this.invoices = invoicedata;
				          this.totalrecord =this.invoices.length;
                 }
                );
 }

  public onPageChange(pageNum: number): void {
  this.pageSize = this.itemsPerPage*(pageNum - 1);
}

public changePagesize(num: number): void {
this.itemsPerPage = this.pageSize + num;
}
}
